import { Component, OnInit } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from "@angular/router";
import { AppSettings } from "../../shared/configuration/appsettings.config";
 


@Component({
  selector: 'invalidLink',
  templateUrl: './invalidlink.component.html'


})
export class InavlidLinkComponent implements OnInit {
  constructor(private title: Title) {

    this.title.setTitle('Invalid Link')
  }
  ngOnInit() {

    //remove all tokens..

    AppSettings.removereCapcha();
    AppSettings.removereferenceNumber();
    AppSettings.removeTempCertificationId();
    AppSettings.removeParticipandId();
    AppSettings.removeParticipandName();


  }
}



